import axios from 'axios'
import { Message, Loading, MessageBox } from 'ccui'
import config from '../config'
import store from '../store'
import Vue from 'vue'
import { addUrlPerFix } from '@/utils'
import { isShowErrorMessage } from 'ccui/lib/utils/util'
const baseURL =
  process.env.NODE_ENV === 'production'
    ? addUrlPerFix(process.env.VUE_APP_BASE_URL)
    : config.baseUrl.dev
// const baseURL = process.env.NODE_ENV === 'production' ? config.baseUrl.pro : config.baseUrl.dev
// create an axios instance
const service = axios.create({
  baseURL: baseURL, // api 的 base_url
  timeout: 10000 // request timeout
})

// request interceptor
let loadingObj
let pageLoading = ''

service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // 加loading
    if (typeof config.data === 'object' && config.data.isShowLoading === true) {
      delete config.data.isShowLoading
      store.commit(
        'SET_LOADINGMESSAGE',
        config.data.loadingMessage || '加载中,请稍等...'
      )
      console.log(store.getters, '==>')
      delete config.data.loadingMessage
      loadingObj = Loading.service({
        lock: true,
        text: store.getters.loadingMessage,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)',
        customClass: 'ccui-custom-loading'
      })
    }
    if (
      typeof config.data === 'object' &&
      config.data.isShowPageLoading === true
    ) {
      pageLoading = config.url
      store.dispatch('setPageLoadingEnable', true)
      store.dispatch('setPageLoading', true)
      delete config.data.isShowPageLoading
    }

    // if (store.getters.token) {
    //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //   config.headers['X-Token'] = getToken()
    // }
    // const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    // console.log('liang')
    // console.log(userInfo)
    // if (userInfo) {
    //   config.data.baseAppId = userInfo.appId
    // }

    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  response => {
    if (loadingObj !== undefined) {
      loadingObj.close()
      loadingObj = undefined
    }
    if (
      store.state.app.pageLoading.pageLoadingStatus &&
      response.config.url === pageLoading
    ) {
      Vue.nextTick(() => {
        store.dispatch('setPageLoading', false)
      })
    }
    // console.log(response)

    if (response.data.code !== '0' && response.data.code != '1' && response.data.code != '001') {
      Message.closeAll()
      if (isShowErrorMessage(response.data.code)) {
        Message({
          message: response.data.message,
          type: 'error',
          showClose: true,
          ccuiCustom: true
        })
      } else {
        MessageBox.alert(
          `<i class="el-icon-warning"></i>系统错误（错误代码：${response.data.code}），请<a class="ccui-message-box-custom-link">联系管理员</a>`,
          '提示',
          {
            distinguishCancelAndClose: true,
            dangerouslyUseHTMLString: true,
            customClass: 'ccui-message-box-custom'
          }
        )
      }
      return Promise.reject(response)
    } else {
      return response
    }
  },
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  /*
  response => {
    const res = response.data
    if (res.code !== 20000) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // 请自行在引入 MessageBox
        // import { Message, MessageBox } from 'element-ui'
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  }, */
  error => {
    if (loadingObj) {
      loadingObj.close()
      loadingObj = undefined
    }
    let message = error.code === 'ECONNABORTED' ? '网络请求超时' : '系统错误'
    Message.closeAll()
    MessageBox.alert(
      `<i class="el-icon-warning"></i>${message}，请<a class="ccui-message-box-custom-link">联系管理员</a>`,
      '提示',
      {
        distinguishCancelAndClose: true,
        dangerouslyUseHTMLString: true,
        customClass: 'ccui-message-box-custom'
      }
    )

    return Promise.reject(error)
  }
)

export default service
